import { IAuthPlugin, IServerMetadata, OidcProvider, SamlProvider, SamlService } from '@adaptiva/data-service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, GuardResult } from '@angular/router';
import { Observable, of, tap } from 'rxjs';

@Injectable()
export class TenableAuthPlugin implements IAuthPlugin {

	public readonly url: string = 'https://cloud.tenable.com/tio/app.html#/myapps';

	protected readonly saml: SamlService = inject(SamlService);

	/**
	 * Tenable customers should be automatically logged in via SAML if:
	 * - Server is a cloud tenant
	 * - No enabled OIDC providers
	 * - Exactly one enabled SAML provider
	 */
	public autoLoginGuard(_metadata: IServerMetadata, _route?: ActivatedRouteSnapshot): Observable<GuardResult> {
		if (!_metadata.cloudTenant)
			return of(true);

		const _continueTo: string = _route?.params?.requestedUrl || '/';
		const _enabledOidc: OidcProvider[] = _metadata.providers?.filter(p => p.enabled) ?? [];
		const _enabledSaml: SamlProvider[] = _metadata.samlProviders?.filter(p => p.enabled) ?? [];
		const _shouldAutoLogin: boolean = _enabledOidc.length === 0 && _enabledSaml.length === 1;

		return of(!_shouldAutoLogin).pipe(
			tap(() => {
				if (_shouldAutoLogin)
					this.saml.login(_enabledSaml[0], _continueTo);
			})
		);
	}

	public logoutRedirect(_metadata: IServerMetadata): Observable<string> {
		let _redirect: string = '';

		if (_metadata.cloudTenant)
			_redirect = this.url;

		return of(_redirect);
	}

}
